import { apiClient } from './client.tsx';
import type {
  CreatePartnerRequest,
  UpdatePartnerRequest,
} from './requests/partner-request.ts';
import type { Partner } from '../models/partner.ts';
import type { BriefParkingLot } from '../models/parking-contract.ts';

type UpdateRequestWithoutId = Omit<UpdatePartnerRequest, 'id'>;

export const fetchPartners = () =>
  apiClient.get(`/v2/partners`).then((res) => res.data.data);

export const fetchPartner = (id: string) =>
  apiClient
    .get<{ data: Partner }>(`/v2/partners/${id}`)
    .then((res) => res.data);

export const createPartners = (request: CreatePartnerRequest) =>
  apiClient.post(`/v2/partners`, request).then((res) => res.data.data);

export const updatePartners = (request: UpdatePartnerRequest) =>
  apiClient
    .put(`/v2/partners/${request.id}`, <UpdateRequestWithoutId>request)
    .then((res) => res.data);

export const fetchBriefChainStores = (partnerId: string) =>
  apiClient
    .get(`/v2/partners/${partnerId}/brief_chain_stores`)
    .then((res) => res.data.data);

export const fetchBriefParkingLots = (partnerId: string) =>
  apiClient
    .get<{
      data: BriefParkingLot[];
    }>(`/v2/partners/${partnerId}/brief_parking_lots`)
    .then((res) => res.data);

export const fetchContracts = (partnerId: string) =>
  apiClient
    .get(`/v2/partners/${partnerId}/contracts`)
    .then((res) => res.data.data);
